/* AXETHREADSCODE: Size Chart Modal + Unit Toggle START */
console.log("AXETHREADS JS LOADED");
(function () {
  function fmtCm(n) {
    const r = Math.round(n * 10) / 10;
    return (Math.abs(r - Math.round(r)) < 1e-9) ? String(Math.round(r)) : String(r.toFixed(1)).replace(/\.0$/, '');
  }

  function initAxSizeChart() {
    const modal = document.querySelector('[data-ax-sizechart-modal]');
    if (!modal) return;

    
        /* AXETHREADSCODE: IMPORTANT
        Dawn re-renders variant-selects on option changes, so direct addEventListener on the button breaks.
        Use delegated document click listeners for [data-ax-open-sizechart] / [data-ax-close-sizechart].
        */
       
        // Open/Close (delegated so it survives Dawn variant re-renders)
        document.addEventListener('click', (e) => {
        const open = e.target.closest('[data-ax-open-sizechart]');
        if (!open) return;

        e.preventDefault();
        e.stopPropagation();

        if (typeof modal.showModal === 'function') modal.showModal();
        else modal.setAttribute('open', 'open');
        }, true);

        document.addEventListener('click', (e) => {
        const close = e.target.closest('[data-ax-close-sizechart]');
        if (!close) return;

        e.preventDefault();
        e.stopPropagation();

        if (typeof modal.close === 'function') modal.close();
        else modal.removeAttribute('open');
        }, true);

    // Click outside to close
    modal.addEventListener('click', (e) => {
      const r = modal.getBoundingClientRect();
      const inside =
        e.clientX >= r.left && e.clientX <= r.right &&
        e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside) modal.close();
    });

    // Unit toggle (inside the rendered chart)
    const chart = modal.querySelector('.ax-sc');
    if (!chart) return;

    const buttons = chart.querySelectorAll('.ax-sc__unit');
    const cells = chart.querySelectorAll('.ax-sc__m');
    const note = chart.querySelector('#ax-sc-note');

    function setUnit(unit) {
      buttons.forEach((b) => {
        const active = b.dataset.unit === unit;
        b.classList.toggle('ax-sc__unit--active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      cells.forEach((td) => {
        const inchesStr = td.getAttribute('data-in');
        const inches = parseFloat(inchesStr);
        if (Number.isNaN(inches)) return;
        td.textContent = (unit === 'cm') ? fmtCm(inches * 2.54) : inchesStr;
      });

      if (note) {
        note.textContent = (unit === 'cm')
          ? 'All sizes measured in centimeters.'
          : 'All sizes measured in inches.';
      }
    }

    buttons.forEach((b) => b.addEventListener('click', () => setUnit(b.dataset.unit)));
    setUnit('in');
  }

  document.addEventListener('DOMContentLoaded', initAxSizeChart);
  
})();

/* AXETHREADSCODE: Keep "Size: X" legend value in sync */
(function () {
  function updateAxSizeLegend() {
    // find currently selected size input (radio) inside variant-selects
    const selected =
      document.querySelector('variant-selects input[name^="Size"]:checked') ||
      document.querySelector('variant-selects input[name*="Size"]:checked');

    if (!selected) return;

    // for Dawn, value is usually like "L", "XL", etc.
    const val = selected.value || selected.getAttribute('value');
    if (!val) return;

    document.querySelectorAll('[data-ax-size-value]').forEach((el) => {
      el.textContent = val;
    });
  }

  document.addEventListener('change', (e) => {
    // Any variant change can impact selected size
    if (e.target && e.target.closest('variant-selects')) updateAxSizeLegend();
  });

  document.addEventListener('DOMContentLoaded', updateAxSizeLegend);
})();
/* AXETHREADSCODE: Size Chart Modal + Unit Toggle END */